import { BrandColorMapType, Country } from 'common/types/common';
import { NewPasswordFormData } from 'views/Invite/PasswordForm';

export interface Role {
  id: string;
  name: string;
  roleDescription?: string;
}

export interface PrompLimit {
  exceeded_limit: boolean;
  id: number;
  prompts_remained: number;
  updated_at: string;
  used_prompts_count: number;
}

interface UserData {
  name: string;
  uuid: string;
  email: string;
  permissions: UserPermissions;
  role: Role;
  brand_funnel_edit: boolean;
  notify_about_data_emails: boolean;
  prompt_limit: PrompLimit;
}

interface UserPermissions {
  internal: boolean;
  chart_edit: boolean;
  chart_folders_edit: boolean;
  segment_edit: boolean;
  user_show: boolean;
  user_edit: boolean;
  view_unpublished_waves: boolean;
}

interface UpdateUserRequestData {
  name: string;
  email: string;
}

interface MoeConfidence {
  high: number;
  medium: number;
}

export enum CalculatedDeltas {
  FIRST_LAST = 'first-last',
  LAST_TWO = 'last-two',
}
interface RawUIPreferences {
  decimalsEnabled?: boolean;
  calculateDeltas?: CalculatedDeltas;
  showBarValue: boolean;
  brandColors: BrandColorMapType;
}
interface UIPreferences {
  decimalsEnabled: boolean;
  calculateDeltas: CalculatedDeltas;
  showBarValue: boolean;
  brandColors: BrandColorMapType;
}

interface AccountPreferences {
  new_design: boolean | null;
  confidence_levels: MoeConfidence | null;
  kpis: Record<string, string> | null;
  ui_preferences: UIPreferences;
}
interface AccountInfos {
  country_code: Country;
  key: string;
  value: string;
}

interface CustomerData {
  name: string;
  tier_name: string;
  id: number;
}

interface WarningBanner {
  text: string;
}

export interface FeatureGates {
  customer: string[];
  studies: Record<string, string[]>;
}

interface AccountDetails {
  functionalities: AccountFunctionality[];
  user: UserData;
  active_study_uuid: string;
  preferences: AccountPreferences;
  features: FeatureGates;
  customer: CustomerData;
  warning_banner: WarningBanner | null;
}

interface AccountFunctionality {
  type: string;
  enabled: boolean;
}

interface UserDetailsResponse {
  user: UserData;
  customer: CustomerData;
  active_study_uuid: string;
  functionalities: AccountFunctionality[];
  preferences: AccountPreferences;
  warning_banner: WarningBanner | null;
}

interface Study {
  uuid: string;
  name: string;
  description: string;
  date: string;
  chart_uuids: string[];
}

interface LoginResponse {
  access_token: string;
  refresh_token: string;
  expires_in: number;
  created_at: number;
}

interface UpdatePassword {
  updatePassword: ({ password }: NewPasswordFormData) => void;
  error: string | undefined;
  message: string | undefined;
  busy: boolean;
}

interface UserInvite {
  setNewPassword: ({ password }: { password: string }) => void;
  message: string | undefined;
  busy: boolean;
}

export type {
  UserPermissions,
  UpdateUserRequestData,
  MoeConfidence,
  RawUIPreferences,
  UIPreferences,
  AccountInfos,
  AccountDetails,
  UserDetailsResponse,
  Study,
  LoginResponse,
  UpdatePassword,
  UserInvite,
};
